import Carousel from "@/components/UI/Carousel.vue";

export default {
    Carousel
}